import type { ChatConfig } from '@dev-streetbeat/chat/types'

import { apiAbsoluteUrl } from '../app/runtime'
import type { AgentConfig } from './types'
import type { AceSession } from './useAceSession'

const PREVIEW_ASSISTANT_NAME = 'credem-advisor'

export function buildAgentChatConfig(
  session: AceSession | null,
  agentConfig?: Partial<AgentConfig>,
): ChatConfig {
  return {
    baseUrl: apiAbsoluteUrl('/api/ace-proxy'),
    // Use the explicit assistant override when the caller specifies one
    // (e.g. ChatPanel for the proposal editor -> opportunity-proposal-editor),
    // otherwise fall back to the tenant's default assistant for the dashboard
    // and other generic chat surfaces.
    assistantName:
      agentConfig?.assistantName ?? session?.default_assistant ?? PREVIEW_ASSISTANT_NAME,
    requestHeadersMap: session
      ? {
          [session.acting_token_header]: session.token,
          [session.tenant_header]: session.ace_tenant_id,
        }
      : {},
    transport: 'sse',
  }
}
